import { Pipe, PipeTransform } from '@angular/core';
import { BookingType, ExternalBookingType } from "@afidium/ts-facade";

@Pipe({
    name: 'extractAgencyBooking'
})
export class ExtractAgencyBookingPipe implements PipeTransform {
    public transform(booking: BookingType): ExternalBookingType {
        if (!booking?.externalBookingArray?.length) {
            return null;
        }
        return booking
            .externalBookingArray
            .find((externalBooking: ExternalBookingType): boolean => externalBooking.xOrigin === 'Agency');
    }
}
